import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";

const GetEmployee = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editEmployee, setEditEmployee] = useState(null);
  const [editForm, setEditForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
  });

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASEURL}/api/employee/getAllEmployees`,
        { withCredentials: true }
      );
      const filteredEmployees = res.data.data.map(
        ({ _id, email, role, firstName, lastName, isActive }) => ({
          _id,
          email,
          role,
          firstName,
          lastName,
          isActive,
        })
      );
      setEmployees(filteredEmployees);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching employees:", err);
      setLoading(false);
    }
  };

  const handleEditClick = (employee) => {
    setEditEmployee(employee._id);
    setEditForm({
      firstName: employee.firstName,
      lastName: employee.lastName,
      email: employee.email,
      role: employee.role,
    });
  };

  const handleStatusToggle = async (employee) => {
    const id = employee._id;
    const currentStatus = employee.isActive;
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_BASEURL}/api/employee/updateEmployee/${id}`,
        { isActive: !currentStatus },
        { withCredentials: true }
      );
      fetchEmployees();
    } catch (err) {
      console.error("Error toggling status:", err);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_BASEURL}/api/employee/updateEmployee/${editEmployee}`,
        editForm,
        { withCredentials: true }
      );
      setEditEmployee(null);
      fetchEmployees();
    } catch (err) {
      console.error("Error updating employee:", err);
    }
  };

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "40px", color: "gray" }}>Loading...</div>;
  }

  return (
    <DashboardLayout>
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "40px 24px" }}>
        <h2 style={{ fontSize: "32px", fontWeight: "bold", textAlign: "center", color: "#facc15", marginBottom: "40px" }}>
          All Employees
        </h2>

        <div style={{ overflowX: "auto", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", borderRadius: "12px", border: "1px solid #ccc", background: "#fff" }}>
          <table style={{ width: "100%", fontSize: "14px", textAlign: "left", borderCollapse: "separate", borderSpacing: "0 12px", color: "#333" }}>
            <thead style={{ background: "linear-gradient(to right, #6366f1, #8b5cf6)", color: "#fff" }}>
              <tr>
                {["First Name", "Last Name", "📧 Email", "🧑‍💼 Role", "Status", "Actions"].map((heading, idx) => (
                  <th key={idx} style={{ padding: "12px 16px", background: "#FFFFFF", color: "black" }}>{heading}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {employees.map((emp, index) => (
                <tr
                  key={emp._id}
                  style={{
                    background: index % 2 === 0 ? "#eef2ff" : "#fff",
                    transition: "background 0.3s",
                    cursor: "pointer"
                  }}
                  onMouseOver={(e) => e.currentTarget.style.background = "#e0e7ff"}
                  onMouseOut={(e) => e.currentTarget.style.background = index % 2 === 0 ? "#eef2ff" : "#fff"}
                >
                  <td style={{ padding: "12px 16px", borderBottom: "1px solid #ccc" }}>{emp.firstName}</td>
                  <td style={{ padding: "12px 16px", borderBottom: "1px solid #ccc" }}>{emp.lastName}</td>
                  <td style={{ padding: "12px 16px", borderBottom: "1px solid #ccc" }}>{emp.email}</td>
                  <td style={{ padding: "12px 16px", borderBottom: "1px solid #ccc" }}>{emp.role}</td>
                  <td style={{ padding: "12px 16px", borderBottom: "1px solid #ccc" }}>
                    <div
                      onClick={() => handleStatusToggle(emp)}
                      style={{
                        width: "50px",
                        height: "25px",
                        backgroundColor: emp.isActive ? "#34d399" : "#d1d5db",
                        borderRadius: "25px",
                        display: "flex",
                        alignItems: "center",
                        padding: "4px",
                        cursor: "pointer",
                        transition: "background-color 0.3s",
                      }}
                    >
                      <div
                        style={{
                          height: "17px",
                          width: "17px",
                          borderRadius: "50%",
                          background: "#fff",
                          transform: emp.isActive ? "translateX(24px)" : "translateX(0px)",
                          transition: "transform 0.3s",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.3)"
                        }}
                      ></div>
                    </div>
                  </td>
                  <td style={{ padding: "12px 16px", borderBottom: "1px solid #ccc" }}>
                    <button
                      onClick={() => handleEditClick(emp)}
                      style={{
                        backgroundColor: "#3b82f6",
                        color: "#fff",
                        padding: "6px 16px",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                        transition: "background-color 0.3s",
                      }}
                      onMouseOver={(e) => e.target.style.backgroundColor = "#2563eb"}
                      onMouseOut={(e) => e.target.style.backgroundColor = "#3b82f6"}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {employees.length === 0 && (
            <div style={{ padding: "24px", textAlign: "center", color: "gray" }}>No employees found.</div>
          )}
        </div>

        {/* Modal for Edit */}
        {editEmployee && (
          <div style={{
            position: "fixed",
            inset: "0",
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "1000",
            animation: "fadeIn 0.3s ease-in-out"
          }}>
            <div style={{
              background: "#fff",
              padding: "32px",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "400px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
              transform: "translateY(0px)",
              animation: "slideIn 0.4s ease"
            }}>
              <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "20px", textAlign: "center" }}>Edit Employee</h2>
              <form onSubmit={handleEditSubmit} style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <input
                  type="text"
                  placeholder="First Name"
                  value={editForm.firstName}
                  onChange={(e) => setEditForm({ ...editForm, firstName: e.target.value })}
                  style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "6px" }}
                  required
                />
                <input
                  type="text"
                  placeholder="Last Name"
                  value={editForm.lastName}
                  onChange={(e) => setEditForm({ ...editForm, lastName: e.target.value })}
                  style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "6px" }}
                  required
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={editForm.email}
                  onChange={(e) => setEditForm({ ...editForm, email: e.target.value })}
                  style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "6px" }}
                  required
                />
                <input
                  type="text"
                  placeholder="Role"
                  value={editForm.role}
                  onChange={(e) => setEditForm({ ...editForm, role: e.target.value })}
                  style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "6px" }}
                  required
                />

                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#10b981",
                      color: "#fff",
                      padding: "10px 20px",
                      borderRadius: "6px",
                      border: "none",
                      cursor: "pointer",
                      fontWeight: "bold",
                      transition: "background-color 0.3s",
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = "#059669"}
                    onMouseOut={(e) => e.target.style.backgroundColor = "#10b981"}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={() => setEditEmployee(null)}
                    style={{
                      backgroundColor: "#6b7280",
                      color: "#fff",
                      padding: "10px 20px",
                      borderRadius: "6px",
                      border: "none",
                      cursor: "pointer",
                      fontWeight: "bold",
                      transition: "background-color 0.3s",
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = "#4b5563"}
                    onMouseOut={(e) => e.target.style.backgroundColor = "#6b7280"}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default GetEmployee;
